<template>
  <v-dialog :value="true" width="40%" persistent scrollable>
    <v-form ref="formAntigenos" @submit.prevent="cerrar(true)">
      <v-card>
        <v-card-title class="text-h3 primary--text"
          >LECTURA MANUAL</v-card-title
        >
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  autofocus
                  label="Ingrese Código Manual"
                  v-model="codigoBarras"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn class="mr-5" text @click.prevent="cerrar(false)">
            Cancelar</v-btn
          >
          <v-spacer> </v-spacer>
          <v-btn
            type="submit"
            v-if="codigoBarras"
            color="primary"
            @click.prevent="cerrar(true)"
            ><v-icon>save</v-icon> Procesar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: 'codigoManual',
  data() {
    return {
      codigoBarras: '',
    };
  },
  methods: {
    cerrar(enviar) {
      this.$emit('cerrar', enviar ? this.codigoBarras : null);
    },
  },
};
</script>

<style></style>
